import { styled } from "@mui/material";
import { Button } from "@pmag/ui-components";

export const StyledButton = styled(Button)(() => ({
    display: "flex",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
}));

export const StyledCip = styled("span")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.core.grey._80,
    marginLeft: theme.spacing(1),
    color: theme.palette.core.white,
    borderRadius: 9,
    height: 18,
    paddingLeft: 6,
    paddingRight: 6,
}));
